import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function ImageAnnotationSvg() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.8"
        cx="28"
        cy="28"
        r="28"
        fill="#FFAB3680"
        fillOpacity="0.8"
      />
      <path
        d="M23.9134 22.0357C23.9134 23.9335 22.3749 25.472 20.4771 25.472C18.5792 25.472 17.0407 23.9335 17.0407 22.0357C17.0407 20.1378 18.5792 18.5993 20.4771 18.5993C22.3749 18.5993 23.9134 20.1378 23.9134 22.0357Z"
        fill="white"
      />
      <path
        d="M14.7498 11.7266C12.2193 11.7266 10.168 13.7779 10.168 16.3084V39.2175C10.168 41.7479 12.2193 43.7993 14.7498 43.7993H42.2407C44.7712 43.7993 46.8225 41.7479 46.8225 39.2175V16.3084C46.8225 13.7779 44.7712 11.7266 42.2407 11.7266H14.7498ZM42.2407 14.0175C43.5059 14.0175 44.5316 15.0431 44.5316 16.3084V31.1993L35.8802 26.7384C35.4392 26.5179 34.9066 26.6044 34.558 26.953L26.0584 35.4526L19.967 31.3917C19.5127 31.0888 18.9077 31.1487 18.5216 31.5348L12.4589 36.9266V16.3084C12.4589 15.0431 13.4846 14.0175 14.7498 14.0175H42.2407Z"
        fill="white"
      />
    </svg>
  )
}

export default function ImageAnnotationIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={ImageAnnotationSvg} {...props} />
}
